import api from "../../api/api";
import API_URL from "../../api/url";
import axios from 'axios';

const DashboardRequest = {
  dashboardCounter: (values) => api.get(`${API_URL.BASEURL}${API_URL.getDashboard}`, values),
  customerRequestList:(values) => api.get(`${API_URL.BASEURL}${API_URL.getCustomerReq}`),
  UpdateServiceReq: (values) => api.post(`${API_URL.BASEURL}${API_URL.updateServiceReq}`, values),
  serviceReqDetail: (id) => api.get(`${API_URL.BASEURL}${API_URL.serviceReqDetail}?salonId=${id}`),

  uploadImage: (formData) => {
    const token = localStorage.getItem("accesstoken");


    return api.post(
      `${API_URL.BASEURL}${API_URL.uploadImg}?moduleName=category`,
      formData,
      {
        headers: {
          token: token ? `${token}` : "",
        },
      }
    );
  }


};



export default DashboardRequest